import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useCategoriesById } from "@hooks/useCategoriesById";
import { TransactionCategory } from "@components/transactions/TransactionCategory";
import { DeletedCategory } from "@components/history/components/DeletedCategory";
import { TransactionListItem } from "@common/schemas/transaction.schema";
import { Category } from "@common/types/category";
import { HistoryCategory } from "@components/history/components/HistoryCategory";

interface SplitCategoryCellProps {
    row: { original: { category: Partial<Category> } };
}

export const SplitCategoryCell = ({ row }: SplitCategoryCellProps) => {
    const categories = useCategoriesById();
    const categoryId = row.original.category?.id;

    if (!categoryId || typeof categoryId !== "string") {
        return (
            <ViewTableCell>
                <DeletedCategory label="Uncategorized" />
            </ViewTableCell>
        );
    }

    const category = categories[categoryId];

    if (category) {
        return (
            <ViewTableCell>
                <TransactionCategory
                    transaction={
                        {
                            ...row.original,
                            categoryId,
                            category,
                        } as unknown as TransactionListItem
                    }
                />
            </ViewTableCell>
        );
    }

    return (
        <ViewTableCell>
            <HistoryCategory
                value={{
                    value: categoryId,
                    valueLabel: row.original.category?.label,
                }}
                field="categoryId"
                resource={row.original}
                categories={categories}
            />
        </ViewTableCell>
    );
};
